/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { client, urlFor } from '@/sanity/client';
import { HeroVideoDialog } from '@/components/ui/hero-video-dialog';
import { VideoLeadForm } from '@/components/ui/video-lead-form';

export const Video = () => {
	const [showForm, setShowForm] = useState(false);
	const [formCompleted, setFormCompleted] = useState(false);
	const [videoContent, setVideoContent] = useState<any>(null);

	useEffect(() => {
		const fetchVideoContent = async () => {
			const data = await client.fetch(`*[_type == "homePage"][0].video{
				title,
				subtitle,
				videoUrl,
				videoThumbnail{
					asset->{
						url
					}
				}
			}`);
			setVideoContent(data);
		};

		fetchVideoContent();
	}, []);

	const handleThumbnailClick = () => {
		setShowForm(true);
	};

	const handleFormSubmit = () => {
		setFormCompleted(true);
		setShowForm(false);
	};

	const handleFormCancel = () => {
		setShowForm(false);
	};

	if (!videoContent) {
		return <div>Loading...</div>;
	}

	return (
		<section className='flex flex-col py-12  w-full bg-amber-50'>
			<div className='px-20 max-md:px-5 max-md:max-w-full'>
				<header className='max-w-full text-neutral-800 w-4xl mx-auto'>
					<h1 className='text-4xl font-bold leading-[40px] max-md:text-[30px] max-md:leading-[40px] text-center'>
						{videoContent.title}
					</h1>
					<h2 className='mt-6 text-2xl leading-snug text-center'>
						{videoContent.subtitle}
					</h2>
				</header>
			</div>

			<div className='flex flex-col items-center mt-16 max-md:mt-10 '>
				<div className='w-full max-w-5xl px-8'>
					{/* Custom video thumbnail with play button */}
					{!formCompleted && (
						<div
							className='relative rounded-xl overflow-hidden shadow-lg cursor-pointer'
							onClick={handleThumbnailClick}
						>
							<img
								src={urlFor(videoContent.videoThumbnail).url()}
								alt='Video Thumbnail'
								className='w-full h-auto aspect-video object-cover'
							/>
							<div className='absolute inset-0 bg-black/30 flex items-center justify-center'>
								<button
									className='w-16 h-16 bg-[#FBB040] rounded-full flex items-center justify-center shadow-lg hover:bg-[#FBB040]/80 transition-colors'
									aria-label='Play video'
								>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='24'
										height='24'
										viewBox='0 0 24 24'
										fill='currentColor'
									>
										<polygon points='5,3 19,12 5,21' />
									</svg>
								</button>
							</div>
						</div>
					)}

					{/* Lead form modal */}
					{showForm && (
						<div className='fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4'>
							<VideoLeadForm
								onSubmit={handleFormSubmit}
								onCancel={handleFormCancel}
							/>
						</div>
					)}

					{/* Video player (only shown after form completion) */}
					{formCompleted && (
						<HeroVideoDialog
							videoSrc={videoContent.videoUrl}
							thumbnailSrc={urlFor(videoContent.videoThumbnail).url()}
							thumbnailAlt='Video Thumbnail'
							className='rounded-xl overflow-hidden shadow-lg'
							animationStyle='from-center'
							buttonColor='#FBB040'
						/>
					)}
					<div className='flex justify-center mt-12'>
						{/* <button
							className='flex items-center gap-2 text-neutral-800 font-bold cursor-pointer'
							onClick={() => navigate('/services')}
							aria-label='Testimonial slide'
						>
							<span>More resources</span>
							<div className='bg-[#FBB040] rounded-full w-8 h-8 flex items-center justify-center'>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='16'
									height='16'
									viewBox='0 0 24 24'
									fill='none'
									stroke='currentColor'
									strokeWidth='3'
									strokeLinecap='round'
									strokeLinejoin='round'
								>
									<path d='M5 12h14M12 5l7 7-7 7' />
								</svg>
							</div>
						</button> */}
					</div>
				</div>
			</div>
		</section>
	);
};
